<template>
  <b-dropdown v-if="getStatus !== 'registRelation' && getStatus !== 'complete' && getStatus !== 'removeRelation' && getStatus !== 'compKey'" right no-caret>
    <template slot="button-content" v-if='isShow'>
      <img class="info-icon" src="static/img/assets/edit.png">
    </template>
    <template v-if="getStatus == 'progress'">
      <b-dropdown-item :to="{ name: 'ObjectiveRegist', params: { item: getItem, id: getKey, isProxy: isProxy, proxyUserId: uid } }">{{$t('okrEditType')}}</b-dropdown-item>
      <b-dropdown-item @click.stop="onClickComplete">{{$t('toComplete')}}</b-dropdown-item>
      <b-dropdown-item @click.stop="onClickDelete">{{$t('deleteStr')}}</b-dropdown-item>
    </template>
    <template v-else-if="getStatus == 'progressKey'">
      <b-dropdown-item :to="{ name: 'KeyresultRegist', params: { item: getItem, id: getKey, isProxy: isProxy, proxyUserId: uid } }">{{$t('keyResultEditType')}}</b-dropdown-item>
      <b-dropdown-item @click.stop="onClickComplete">{{$t('toComplete')}}</b-dropdown-item>
      <!-- <b-dropdown-item v-if="getItem.isComplete" @click.stop="onClickIncomplete">{{$t('incomplete')}}</b-dropdown-item> -->
      <b-dropdown-item @click.stop="onClickDelete">{{$t('deleteStr')}}</b-dropdown-item>
    </template>
    <!-- <template v-else-if="getStatus == 'removeRelation'">
      <b-dropdown-item @click.stop="onClickRelationRemove">{{$t('deleteStr')}}</b-dropdown-item>
    </template> -->
    <template v-else>
      <b-dropdown-item :to="{ name: 'ObjectiveRegist', params: { item: getItem, id: getKey, isProxy: isProxy, proxyUserId: uid } }">{{$t('editStr')}}</b-dropdown-item>
      <b-dropdown-item @click.stop="onClickDelete">{{$t('deleteStr')}}</b-dropdown-item>
    </template>
  </b-dropdown>
  <button type="button" v-else-if="getStatus == 'removeRelation'" @click.stop="onClickRelationRemove" class="btn btn-danger">{{$t('deleteStr')}}</button>
  <button type="button" v-else-if="getStatus == 'registRelation'" @click.stop="onClickRelationDelete" class="btn btn-danger">{{$t('deleteStr')}}</button>
  <button type="button" v-else-if="getStatus == 'complete' || 'compKey'" @click.stop="onClickIncomplete" class="btn btn-danger">{{$t('incomplete')}}</button>

  <!-- <b-dropdown v-if="getStatus !== 'registRelation' && getStatus !== 'complete'" right no-caret>
  <template slot="button-content" v-if='isShow'>
      <img src="static/img/assets/edit.png">
  </template>
  <template v-if="getStatus == 'progress'">
    <b-dropdown-item :to="{ name: 'ObjectiveRegist', params: { item: getItem, id: getKey } }">{{$t('editStr')}}</b-dropdown-item>
    <b-dropdown-item @click.stop="onClickComplete">{{$t('secStr')}}</b-dropdown-item>
    <b-dropdown-item @click.stop="onClickDelete">{{$t('deleteStr')}}</b-dropdown-item>
  </template>
  <template v-else-if="getStatus == 'progressKey'">
    <b-dropdown-item :to="{ name: 'KeyresultRegist', params: { item: getItem, id: getKey } }">{{$t('editStr')}}</b-dropdown-item>
    <b-dropdown-item v-if="!getItem.isComplete" @click.stop="onClickComplete">{{$t('secStr')}}</b-dropdown-item>
    <b-dropdown-item v-if="getItem.isComplete" @click.stop="onClickIncomplete">{{$t('incomplete')}}</b-dropdown-item>
    <b-dropdown-item @click.stop="onClickDelete">{{$t('deleteStr')}}</b-dropdown-item>
  </template>
  <template v-else-if="getStatus == 'removeRelation'">
    <b-dropdown-item @click.stop="onClickRelationRemove">削除</b-dropdown-item>
  </template>
  <template v-else>
    <b-dropdown-item :to="{ name: 'ObjectiveRegist', params: { item: getItem, id: getKey } }">{{$t('editStr')}}</b-dropdown-item>
    <b-dropdown-item @click.stop="onClickDelete">{{$t('deleteStr')}}</b-dropdown-item>
  </template>
</b-dropdown>
<button type="button" v-else-if="getStatus == 'registRelation'" @click.stop="onClickRelationDelete" class="btn btn-danger">{{$t('deleteStr')}}</button>
<button type="button" v-else-if="getStatus == 'complete'" @click.stop="onClickIncomplete" class="btn btn-danger">未完了に戻す</button> -->

</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'OkrDropDown',
  props: {
    tag: String,
    item: Object,
    id: String,
    isProxy: false,
    uid: ''
  },
  computed: {
    ...mapGetters('objectives/', [
      'getCurrentObjectives',
      'getObjectivesByUserId'
    ]),
    ...mapGetters('keyResults/', [
      'getCurrentKeyresults',
      'getKeyresultsByUserId'
    ]),
    getStatus: function () {
      return this.tag
    },
    getItem: function () {
      return this.item
    },
    getKey: function () {
      return this.id
    }
  },
  data () {
    return {
      isShow: false,
      removeTarget: {
        id: '',
        target: ''
      },
      completeTarget: {
        id: '',
        target: '',
        isComplete: true
      }
    }
  },
  beforeMount: function () {
    if (this.uid) {
      if (Object.keys(this.getObjectivesByUserId(this.uid)).filter(x => x === this.id).length > 0 || Object.keys(this.getKeyresultsByUserId(this.uid)).filter(x => x === this.id).length > 0) {
        this.isShow = true
      } else if (this.tag === 'registRelation') {
        this.isShow = true
      }
    } else {
      if (Object.keys(this.getCurrentObjectives).filter(x => x === this.id).length > 0 || Object.keys(this.getCurrentKeyresults).filter(x => x === this.id).length > 0) {
        this.isShow = true
      } else if (this.tag === 'registRelation') {
        this.isShow = true
      }
    }
  },
  methods: {
    ...mapActions({
      removeItem: 'REMOVE_ITEM'
    }),
    ...mapActions('okrs/', {
      setItemComplete: 'SET_ITEM_COMPLETENESS',
      removeIscomplete: 'REMOVE_ITEM_ISCOMPLETE'
    }),
    onClickDelete: function () {
      // let removeTarget
      this.removeTarget.id = this.id
      switch (this.tag) {
        case 'progress':
          this.removeTarget.target = 'objectives'
          break
        case 'progressKey':
          this.removeTarget.target = 'keyresults'
          this.removeTarget.parentId = this.getCurrentKeyresults[this.removeTarget.id].parentObjId
          break
      }
      // let $t = this.$t
      this.$swal({
        // sweetAlartの処理
        title: this.$t('popTitleStrType'),
        text: this.$t('doDeleteStr'),
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        type: 'warning',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false,
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 3000
      }).then((result) => {
        if (result.value) {
          // okが押下されたら
          console.log('true')
          this.removeItem(this.removeTarget)
          // emitFunction()
          this.$swal({
            title: this.$t('compDeleteStr'),
            type: 'success',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            padding: '2rem',
            timer: 3000
          })
        } else {
          // cancelが押下されたら
          console.log('false')
        }
      })
    },
    onClickRelationDelete: function () {
      this.$emit('delete-relation', this.id, this.item.targetType)
    },
    onClickRelationRemove: function () {
      this.$emit('remove-relation')
    },
    onClickComplete: function () {
      this.completeTarget.id = this.id
      this.completeTarget.isComplete = 1
      this.completeTarget.modifiedAt = new Date().getTime() / 1000
      console.log('this.completeTarget::', this.getItem)
      switch (this.tag) {
        case 'progress':
          this.completeTarget.target = 'objectives'
          this.completeTarget.parentObjId = false
          break
        case 'progressKey':
          this.completeTarget.target = 'keyresults'
          this.completeTarget.parentObjId = this.getItem.parentObjId
          break
      }
      // let $t = this.$t
      this.$swal({
        title: this.$t('popTitleStrType'),
        text: this.$t('popMessageStr16'),
        type: 'question',
        showCancelButton: true,
        reverseButtons: false,
        cancelButtonColor: '#f64846',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 3000
      }).then((result) => {
        if (result.value) {
          this.setItemComplete(this.completeTarget)
          this.$swal({
            title: this.$t('popTitleStr8'),
            text: this.$t('popMessageStr17'),
            type: 'success',
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            allowOutsideClick: false,
            padding: '2rem'
            // timer: 3000
          })
        } else {
          console.log('setItemComplete -> cancel')
        }
      })
    },
    onClickIncomplete: function () {
      const $t = this.$t
      this.completeTarget.id = this.id
      console.log(this.completeTarget.id)
      // this.completeTarget.isComplete = false
      switch (this.tag) {
        case 'progress':
          this.completeTarget.target = 'objectives'
          this.completeTarget.parentObjId = false
          break
        case 'compKey':
          this.completeTarget.target = 'keyresults'
          this.completeTarget.parentObjId = this.getItem.parentObjId
          break
        case 'complete':
          this.completeTarget.target = 'objectives'
          this.completeTarget.parentObjId = false
          break
      }
      this.removeIscomplete(this.completeTarget)
      this.$swal({
        title: $t('popTitleStr8'),
        text: $t('popMessageStr15'),
        type: 'success',
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        padding: '2rem',
        timer: 3000
      })
    },
    onClickKeyDelete: function () {
      console.log('実装中です')
    },
    onClickKeyComplete: function () {
      console.log('実装中です')
    }
  }
}
</script>
<style scoped>
.dropdown-item {
  color: #151b1e;
}
</style>



// WEBPACK FOOTER //
// src/components/Okr/OkrDropDown.vue